import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { termsService } from "../services/termsService";

export const useAgreementCheck = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  const checkAgreementStatus = useCallback(async () => {
    // 이미 체크했거나 체크 중이면 중복 실행 방지
    if (hasChecked || isChecking) return;

    // 인증 토큰이 없으면 체크하지 않음
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return;

    // 이미 auth 페이지에 있으면 체크하지 않음
    if (location.pathname.startsWith("/auth")) return;

    // 관리자 페이지에 있으면 체크하지 않음
    if (location.pathname.startsWith("/admin")) return;

    // 운영자 페이지에 있으면 체크하지 않음
    if (location.pathname.startsWith("/operator")) return;

    // 콜백 페이지에 있으면 체크하지 않음
    if (location.pathname.includes("/callback")) return;

    try {
      setIsChecking(true);
      const agreementStatus = await termsService.checkAgreementStatus();

      // 약관 동의가 완료되지 않은 경우
      if (!agreementStatus.hasAllTermsResponses) {
        navigate("/auth/terms", { replace: true });
        return;
      }

      // 데이터셋 동의가 완료되지 않은 경우
      if (!agreementStatus.hasAllDatasetsResponses) {
        navigate("/auth/data-transfer", { replace: true });
        return;
      }

      // 모든 동의가 완료된 경우
      setHasChecked(true);
    } catch (error) {
      console.error("동의 상태 확인 중 오류:", error);
      // 오류가 발생해도 체크 완료로 처리하여 무한 루프 방지
      setHasChecked(true);
    } finally {
      setIsChecking(false);
    }
  }, [hasChecked, isChecking, location.pathname, navigate]);

  // 컴포넌트 마운트 시 동의 상태 확인
  useEffect(() => {
    checkAgreementStatus();
  }, [location.pathname, checkAgreementStatus]); // 경로 변경 시에도 체크

  // 새로고침 시 동의 상태 재확인을 위한 함수
  const recheckAgreementStatus = () => {
    setHasChecked(false);
    checkAgreementStatus();
  };

  return {
    isChecking,
    hasChecked,
    recheckAgreementStatus,
  };
};
